import {
  REQUEST_PASSWORD_REQUEST,
  REQUEST_PASSWORD_SUCCESS,
  REQUEST_PASSWORD_FAILURE,
  RESET_FORGET_PASSWORD,
} from '../../constants/ActionTypes'
import { UsersApi } from '../api/UsersApi';

const requestPasswordRequest = () => ({
  type: REQUEST_PASSWORD_REQUEST,
});

const requestPasswordSuccess = () => ({
  type: REQUEST_PASSWORD_SUCCESS,
});

const requestPasswordFailure = (error) => ({
  type: REQUEST_PASSWORD_FAILURE,
  payload: {
    error: error
  }
});

export const requestPassword = (requestInfo) => {

  return (dispatch) => {
    dispatch(requestPasswordRequest());

    UsersApi.requestPassword(requestInfo, dispatch)
      .then(() => {
        dispatch(requestPasswordSuccess());
      })
      .catch(error => {
        dispatch(requestPasswordFailure(error.response.data));
      })
  };
}

export const resetForgetPassword = () => ({
  type: RESET_FORGET_PASSWORD,
});



// WEBPACK FOOTER //
// ./src/redux/actions/ForgetPassword.js